import type { UseQueryResult } from '@tanstack/react-query';
import { useMemo } from 'react';

export function useQueryMemoized<T extends UseQueryResult>(query: T) {
  const memoized = useMemo(
    () => ({
      data: query.data,
      error: query.error,
      status: query.status,
      refetch: query.refetch,
      dataUpdatedAt: query.dataUpdatedAt,
      errorUpdateCount: query.errorUpdateCount,
      errorUpdatedAt: query.errorUpdatedAt,
      failureCount: query.failureCount,
      failureReason: query.failureReason,
      fetchStatus: query.fetchStatus,
      isError: query.isError,
      isFetched: query.isFetched,
      isFetchedAfterMount: query.isFetchedAfterMount,
      isFetching: query.isFetching,
      isLoading: query.isLoading,
      isLoadingError: query.isLoadingError,
      isPaused: query.isPaused,
      isPending: query.isPending,
      isPlaceholderData: query.isPlaceholderData,
      isRefetchError: query.isRefetchError,
      isRefetching: query.isRefetching,
      isStale: query.isStale,
      isSuccess: query.isSuccess,
    }),
    [
      query.data,
      query.error,
      query.status,
      query.refetch,
      query.dataUpdatedAt,
      query.errorUpdateCount,
      query.errorUpdatedAt,
      query.failureCount,
      query.failureReason,
      query.fetchStatus,
      query.isError,
      query.isFetched,
      query.isFetchedAfterMount,
      query.isFetching,
      query.isLoading,
      query.isLoadingError,
      query.isPaused,
      query.isPending,
      query.isPlaceholderData,
      query.isRefetchError,
      query.isRefetching,
      query.isStale,
      query.isSuccess,
    ]
  );

  return memoized as T;
}
